const app = angular.module('landingPage');

app.directive('giEditorialDropdown', ($window, $location, $timeout) => ({
  link(scope, elem, attr) {
    scope.dropdownOpen = false;

    scope.toggleDropdown = function () {
      if (scope.dropdownOpen) return scope.closeDropdown();
      scope.dropdownOpen = true;
    };

    scope.closeDropdown = function () {
      scope.dropdownOpen = false;
    };
  },
}));
